import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Divider } from '../../Divider/Divider.component';
import { Flex } from '../../containers/Flex/Flex.component';
import { Icon } from '../../icons/Icon.component';
import { Text } from '../../typography';
import { IPopMenuProps } from '../PopMenu.component';
import { ButtonsConfig } from '../types';
import { ButtonBar } from './ButtonBar';

interface IPopMenuPanelProps {
  closePopover: () => void;
  title: IPopMenuProps['subTitle'];
  menuComponent: IPopMenuProps['menuComponent'];
  buttonsConfig: ButtonsConfig;
  width?: IPopMenuProps['width'];
  height?: IPopMenuProps['height'];
}

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

export const PopMenuPanel: React.FC<IPopMenuPanelProps> = ({
  closePopover,
  title,
  menuComponent,
  buttonsConfig,
  width,
  height,
}) => {
  const theme = useTheme();

  return (
    <Flex flexDirection={'column'} width={width || 440} height={height || 290}>
      <Flex pt={4} pb={2} px={4} width={'100%'} justifyContent="space-between" alignItems="center">
        <Text size={14} weight={600} color={'royalBlue.1000'}>
          {title}
        </Text>
        <StyledIcon icon={'xmark-regular'} onClick={closePopover} />
      </Flex>
      {menuComponent}
      <Divider color={theme.popMenu.panel.dividerColor} size={'m'} />
      <ButtonBar buttonsConfig={buttonsConfig} closePopover={closePopover} />
    </Flex>
  );
};
